__webpack_require__.p = "https://insp.demo.boolanga.com/";